<template>
  <div id="app">
    <router-view :key="key" />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    // console.clear()
  },
  data() {
    return {
      routerRefresh: true
    };
  },
  metaInfo() {
    return {
      title: this.$route.name,
      meta: [
        {
          name: "keywords",
          content: this.keywords
        }
      ]
    };
  },
  computed: {
    key() {
      return this.$route.path + Math.random();
    }
  }
};
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue